import TermSearchModule from '~/lib/vue/modules/termsearch';

export default (services, namespace='search') => {
  return TermSearchModule.create({
    services,
    url: '/search/jobs',
    placeholder: 'Find jobs',
  });
};
